// El QR del segundo factor en un marco de papel (Peaje U-02).
//
// `CodigoQR` ya pinta tinta y papel fijos con su zona de silencio; aquí
// solo se elige el lado —200 px en teléfono, 240 desde 640 px— y se le da
// un margen blanco propio que no cambia con el tema. 200 + 24 de marco
// caben en los 248 px útiles de la tarjeta a 320 px.
import { useEffect, useState } from 'react';
import CodigoQR, { PAPEL } from '../ui/CodigoQR';

const CONSULTA = '(min-width: 640px)';
export const LADO_TELEFONO = 200;
export const LADO_ESCRITORIO = 240;

function esGrande() {
  try { return !!globalThis.window?.matchMedia?.(CONSULTA).matches; } catch { return false; }
}

export default function MarcoQR({ valor, etiqueta }) {
  const [grande, setGrande] = useState(esGrande);
  useEffect(() => {
    const mq = globalThis.window?.matchMedia?.(CONSULTA);
    if (!mq?.addEventListener) return undefined;
    const cambio = () => setGrande(mq.matches);
    mq.addEventListener('change', cambio);
    return () => mq.removeEventListener('change', cambio);
  }, []);
  return (
    <div className="inline-block rounded-lg p-3" style={{ background: PAPEL }}>
      <CodigoQR valor={valor} tamano={grande ? LADO_ESCRITORIO : LADO_TELEFONO} etiqueta={etiqueta} />
    </div>
  );
}
